import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 17.999,
	height: 17.993,
	viewBox: "0 0 17.999 17.993",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_3973",
				"data-name": "Rectangle 3973",
				width: 17.993,
				height: 17.144,
				fill: "none"
			})
		}) }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_8090",
			"data-name": "Group 8090",
			transform: "translate(2.16 -4.5)",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_3974",
				"data-name": "Rectangle 3974",
				width: 17.993,
				height: 17.993,
				transform: "translate(-2.154 4.5)",
				fill: "none"
			}), /* @__PURE__ */ _jsx("g", {
				id: "Group_8089",
				"data-name": "Group 8089",
				transform: "translate(-2.16 4.878)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_8088",
					"data-name": "Group 8088",
					clipPath: "url(#clip-path)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_19422",
						"data-name": "Path 19422",
						d: "M5.5,12a2.5,2.5,0,0,0-2.449,2H0v1H3.049A2.5,2.5,0,0,0,8,15h10V14H8a2.5,2.5,0,0,0-2.5-2m0,4A1.5,1.5,0,1,1,7,14.5,1.5,1.5,0,0,1,5.5,16M8,2A2.5,2.5,0,0,0,3.1,2H0V3H3.049A2.5,2.5,0,0,0,8,3h10V2ZM5.5,4A1.5,1.5,0,1,1,7,2.5,1.5,1.5,0,0,1,5.5,4m5.948,2A2.5,2.5,0,0,0,9,8H0V9H9a2.5,2.5,0,0,0,4.9,0h4.1V8h-4.1a2.5,2.5,0,0,0-2.449-2m0,4a1.5,1.5,0,1,1,.051,0h-.051",
						transform: "translate(0 0)"
					})
				})
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
